<app-devops-placeholder-card
  titleKey="liveDashboard.devops.pipelineTitle"
  descriptionKey="liveDashboard.devops.description"
/>
